import {
  FILTER_KEY_EDITOR,
  FILTER_KEY_FORMAT,
  FILTER_KEY_PUBLISHING_DATE,
} from '../dynamics/filters-items-dynamics.config'
import { TrendsItemFilterActionInterface } from '../../interface/dynamics/trends-item-filter-action.interface'
import { ReactComponent as ReleaseIcon } from '../../../assets/icons/app/release-year.icon.svg'
import { ReactComponent as FormatIcon } from '../../../assets/icons/app/format.icon.svg'
import { ReactComponent as EditorIcon } from '../../../assets/icons/app/editor.icon.svg'
import {
  ItemFilterActionEnum,
  ItemSortActionEnum,
} from '../../enums/item-filter-action.enum'

export const PrivateFiltersItemsAnalyticsConfig: TrendsItemFilterActionInterface[] =
  [
    {
      value: ItemFilterActionEnum.ReleaseYear,
      name: 'webApp.dynamics.results.filters.columns.publishingDate',
      icon: <ReleaseIcon className="w-4 h-4" />,
      active: false,
      key: FILTER_KEY_PUBLISHING_DATE,
    },
    {
      value: ItemSortActionEnum.Editor,
      name: 'webApp.dynamics.results.filters.columns.editor',
      icon: <EditorIcon className="w-4 h-4" />,
      active: false,
      key: FILTER_KEY_EDITOR,
    },
    {
      value: ItemSortActionEnum.Format,
      name: 'webApp.dynamics.results.filters.columns.format',
      icon: <FormatIcon className="w-4 h-4" />,
      active: false,
      key: FILTER_KEY_FORMAT,
    },
  ]
